import { convertToLocalTime } from 'utils';
import { InfoBlock } from '../InfoBlock';
import { BidHistorySection } from 'pages/Shared/VehicleDetails/components';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { BidHistoryProps } from './types';
import { VEHICLE_STATUSES } from 'constants';

export const AAOffers = ({ vehicle, initiallyCollapsed }: BidHistoryProps) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);

  const vehicleOfferBids = (offerAuction?.offerBids || []).map(bid => ({
    id: bid.id,
    bid: bid.amount,
    bidder: bid.bidder?.dealership_name,
    date: convertToLocalTime(bid.created_at, true),
    created_at: bid.created_at
  }));

  const isAwarded = vehicle.status === VEHICLE_STATUSES.AWARDED;
  const offerAuctionStarted = (offerAuction?.offerBids?.length ?? 0) > 0;
  const awardInfo =
    isAwarded && offerAuctionStarted && vehicle.awarded_user
      ? { amount: vehicle.vehicle_price, buyerName: vehicle.awarded_user.dealership_name }
      : undefined;

  return (
    <InfoBlock>
      <BidHistorySection
        initiallyCollapsed={initiallyCollapsed}
        startingBid={vehicle.starting_bid}
        bids={vehicleOfferBids}
        auctionType={'autoaxess'}
        proxyBid={offerAuction?.offerProxyBid}
        type="offers"
        awardInfo={awardInfo}
      />
    </InfoBlock>
  );
};
